// Alfred sends null for "no limit"; Number(null) is 0, which reads as a zero cap.
export const parseAlfredLimit = (value: string | null | undefined): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

/** i18n key + params for the "Min X — Max Y" hint, dropping whichever side is missing. */
export const alfredLimitsHint = (
  limits: { min_amount: string | null; max_amount: string | null },
  currency: string
): { key: string; options: Record<string, string> } | null => {
  const hasMin = parseAlfredLimit(limits.min_amount) !== null;
  const hasMax = parseAlfredLimit(limits.max_amount) !== null;
  const minAmount = limits.min_amount ?? "";
  const maxAmount = limits.max_amount ?? "";
  if (hasMin && hasMax) {
    return { key: "DEPOSIT_FORM.LIMITS_HINT", options: { minAmount, maxAmount, currency } };
  }
  if (hasMin) {
    return {
      key: "DEPOSIT_FORM.LIMITS_HINT_MIN",
      options: { defaultValue: "Min {{minAmount}} {{currency}}", minAmount, currency },
    };
  }
  if (hasMax) {
    return {
      key: "DEPOSIT_FORM.LIMITS_HINT_MAX",
      options: { defaultValue: "Max {{maxAmount}} {{currency}}", maxAmount, currency },
    };
  }
  return null;
};

export const clampToAlfredLimits = (
  amount: number,
  limits: { min_amount: string | null; max_amount: string | null }
): number => {
  const min = parseAlfredLimit(limits.min_amount);
  const max = parseAlfredLimit(limits.max_amount);
  let clamped = amount;
  if (max !== null && clamped > max) clamped = max;
  if (min !== null && clamped < min) clamped = min;
  return clamped;
};
